/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ItemVariantTypesItemVariantTypeIdAssociationVariantsPut$Params {
  'Active-Tenant-Identifier': string;
  itemVariantTypeId: string;
      body: Array<string>
}

export function itemVariantTypesItemVariantTypeIdAssociationVariantsPut(http: HttpClient, rootUrl: string, params: ItemVariantTypesItemVariantTypeIdAssociationVariantsPut$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, itemVariantTypesItemVariantTypeIdAssociationVariantsPut.PATH, 'put');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.path('itemVariantTypeId', params.itemVariantTypeId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

itemVariantTypesItemVariantTypeIdAssociationVariantsPut.PATH = '/item-variant-types/{itemVariantTypeId}/association/variants';
